import { string } from 'prop-types'
import { connectRefinementList } from 'react-instantsearch-dom'

import { RefinementListNonConnected } from 'shared/experiments/components/NewSerp/RefinementList'
import { updateOptionLabels } from 'views/components/organisms/AlgoliaInstantSearch/Algolia/PrescriptionTypesFilter/helpers'

const PrescriptionTypesFilter = ({
  items: itemsSrc,
  trueOptionLabel,
  falseOptionLabel,
  ...restProps
}) => {
  const labels = itemsSrc.map(item => item.label)
  let items = []

  if (
    itemsSrc.length === 2 &&
    labels.includes('true') &&
    labels.includes('false')
  ) {
    items = updateOptionLabels(itemsSrc, trueOptionLabel, falseOptionLabel)
  }

  return <RefinementListNonConnected {...restProps} items={items} />
}

PrescriptionTypesFilter.propTypes = {
  ...RefinementListNonConnected.propTypes,
  trueOptionLabel: string.isRequired,
  falseOptionLabel: string.isRequired,
}

PrescriptionTypesFilter.defaultProps = {
  ...RefinementListNonConnected.defaultProps,
}

export default connectRefinementList(PrescriptionTypesFilter)
